import React from 'react';
import { LockIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { PackFan } from '../PackFan';
import { Countdown } from '../Countdown';
import { PaymentBadges } from '../PaymentBadges';
import { BONOS } from '../../data/content';
import { goToCheckout } from '../../utils/scroll';
import { AHORRO, PRECIO_TACHADO, PRECIO_VENTA, VALOR_TOTAL } from '../../utils/constants';
const PASOS: string[] = ['Pagás con tarjeta o Mercado Pago, en un solo pago.', 'Te llega el acceso por mail, al instante.', 'Imprimís la hoja del día 1 y arrancan esa misma tarde.'];
const CONFIANZA: Array<{
  icon: React.ReactNode;
  texto: string;
}> = [{
  icon: <LockIcon className="w-5 h-5" aria-hidden="true" data-id="element-182" data-mp="3jxmd1ibfylxf" />,
  texto: 'Transacción segura con SSL'
}, {
  icon: <ShieldCheckIcon className="w-5 h-5" aria-hidden="true" data-id="element-183" data-mp="3nyofe80nne3m" />,
  texto: 'Garantía de 14 días'
}, {
  icon: <CreditCardIcon className="w-5 h-5" aria-hidden="true" data-id="element-184" data-mp="3su3rovj0l1xx" />,
  texto: 'Pago único, sin suscripción'
}];
export function Offer() {
  return <section id="oferta" className="bg-crema-alt py-16 sm:py-20 px-5 overflow-visible" style={{
    overflow: 'visible'
  }} aria-labelledby="oferta-titulo" data-id="element-185" data-mp="1klqbo8jv8lq3">
      <div className="max-w-3xl mx-auto rounded-3xl bg-white shadow-2xl border-2 border-coral overflow-visible" data-id="element-186" data-mp="1bka2230vknmx">
        <div className="bg-coral text-white text-center px-6 py-5 rounded-t-[1.35rem]" data-id="element-187" data-mp="16mgylhqyi7qc">
          <p className="font-serif text-2xl sm:text-3xl font-bold" id="oferta-titulo" data-id="element-188" data-mp="23chgqxwtlpyo">
            Kit de Caligrafía: 400 Actividades en 21 Días
          </p>
          <p className="mt-1 text-sm sm:text-base text-white/85" data-id="element-189" data-mp="1zch49ita7ou9">6 tomos + 6 bonos · Acceso inmediato</p>
        </div>

        <div className="px-5 sm:px-10 py-10 overflow-visible" style={{
        overflow: 'visible'
      }} data-id="element-190" data-mp="1pkksx626q283">
          <div className="max-w-xl mx-auto overflow-visible" style={{
          overflow: 'visible'
        }} data-id="element-191" data-mp="2mzyomta7vkn7">
            <PackFan lazy data-id="element-192" data-mp="2n1ruw7gx42uo" />
          </div>

          <ul className="mt-8 divide-y divide-crema-alt border-y border-crema-alt" data-id="element-193" data-mp="2i878lcoosxbb">
            <li className="flex items-center justify-between gap-4 py-3" data-id="element-194" data-mp="314z3ywvqshgb">
              <span className="text-tinta font-semibold" data-id="element-195" data-mp="364kabsd8rs32">Kit completo — 6 tomos</span>
              <span className="text-tinta/70" data-id="element-196" data-mp="366en2jed0dw2">{PRECIO_TACHADO}</span>
            </li>
            {BONOS.map((bono, i) => <li key={bono.titulo} className="flex items-center justify-between gap-4 py-3" data-id="element-197" data-mp="2weikav1bvzli" data-mpi={i}>
                <span className="text-tinta/80 text-sm sm:text-base" data-id="element-198" data-mp="2if95nzsrtdjn">
                  Bono {i + 1} — {bono.titulo}
                </span>
                <span className="shrink-0 text-sm sm:text-base" data-id="element-199" data-mp="2nevjaacigvsz">
                  <span className="line-through text-tinta/40 mr-2" data-id="element-200" data-mp="29et5az7bqmj0">{bono.valor}</span>
                  <span className="text-coral font-bold" data-id="element-201" data-mp="2dfmtzuslc5cy">GRATIS</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 text-center" data-id="element-202" data-mp="7o9ddsuws0dj">
            <p className="text-tinta/60" data-id="element-203" data-mp="7l3pggy0n4je">
              Valor total del pack: <span className="line-through" data-id="element-204" data-mp="bnzzhj9hpsbq">{VALOR_TOTAL}</span>
            </p>
            <p className="mt-2 font-serif text-5xl sm:text-6xl font-bold text-violeta leading-none" data-id="element-205" data-mp="1w7lvs2abm2h7">
              {PRECIO_VENTA}
            </p>
            <p className="mt-3 text-coral font-bold text-lg" data-id="element-206" data-mp="1s35ru6k9p54m">Ahorrás {AHORRO} hoy</p>
          </div>

          <Countdown className="mt-8" tone="light" data-id="element-207" data-mp="25y87vmitwav5" />

          <button type="button" onClick={goToCheckout} className="mt-8 w-full bg-coral hover:bg-coral-oscuro text-white font-bold text-xl sm:text-2xl py-6 rounded-2xl animate-cta transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40" data-id="element-208" data-mp="214m0o9vfoz6q">
            LO QUIERO AHORA
          </button>

          <PaymentBadges className="mt-6" data-id="element-209" data-mp="2jwekbdom581s" />

          <ul className="mt-6 grid gap-3 sm:grid-cols-3 text-center" data-id="element-210" data-mp="2jxg7uhmtfn0e">
            {CONFIANZA.map(item => <li key={item.texto} className="flex sm:flex-col items-center justify-center gap-2 text-sm text-tinta/70" data-id="element-211" data-mp="uhgtmm4cb7dw">
                <span className="text-dorado" data-id="element-212" data-mp="rvqwxocvvdeo">{item.icon}</span>
                <span data-id="element-213" data-mp="vydrhx0xvcfk">{item.texto}</span>
              </li>)}
          </ul>

          <div className="mt-8 rounded-2xl bg-crema border border-crema-alt p-6" data-id="element-214" data-mp="w08hhpr2huqi">
            <h3 className="font-serif text-xl font-bold text-violeta" data-id="element-215" data-mp="10ya1ccwbhy31">
              ¿Qué pasa después de comprar?
            </h3>
            <ol className="mt-4 space-y-3" data-id="element-216" data-mp="8930h79e4wem">
              {PASOS.map((paso, i) => <li key={paso} className="flex items-start gap-3" data-id="element-217" data-mp="86ypk5d2qx4u" data-mpi={i}>
                  <span className="w-7 h-7 shrink-0 rounded-full bg-violeta text-crema text-sm font-bold flex items-center justify-center" data-id="element-218" data-mp="d8fpnynqifkd">
                    {i + 1}
                  </span>
                  <span className="text-tinta/85" data-id="element-219" data-mp="mzaacylc173p">{paso}</span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}